import { Box, Skeleton } from '@mui/material';
import { BuildCartCard } from './BuildCartCard';
import { loadingCardGridSx } from './styles';

type ResponsiveSize =
  | string
  | number
  | {
      xs?: string | number;
      sm?: string | number;
      md?: string | number;
      lg?: string | number;
      xl?: string | number;
    };

type LoadingCardProps = {
  rows: number;
  height?: number | string;
  titleWidth?: string;
  cardWidth?: ResponsiveSize;
  cardMaxWidth?: ResponsiveSize;
};

export const LoadingCard = ({
  rows,
  height,
  titleWidth = '40%',
  cardWidth,
  cardMaxWidth,
}: LoadingCardProps) => (
  <BuildCartCard
    sx={{
      height,
      ...(cardWidth ? { width: cardWidth } : {}),
      ...(cardMaxWidth ? { maxWidth: cardMaxWidth } : {}),
    }}
  >
    <Skeleton
      variant="text"
      width={titleWidth}
      height={60}
      sx={{ background: 'rgba(0, 0, 0, 0.04)' }}
    />
    <Box sx={loadingCardGridSx}>
      {[...Array(rows)].map((_, index) => (
        <Skeleton key={index} variant="rounded" height={60} />
      ))}
    </Box>
  </BuildCartCard>
);
